
$(() => {
    
    

    //ドロワーの開閉
    $('.js-nav-trg').on('click', () => {
        $('.org_nav').toggleClass('open')
    })

    //リンククリックで画面をフェードアウト
    $('a:not([href^="#"]):not([target], .jdgm-paginate__page, .jdgm-star,.jdgm-paginate__load-more)').on("click", (function (o) {
        return o.preventDefault(),
            "" !== (e = $(this).attr("href")) && ($("body").addClass("fadeout"),
                setTimeout((function () {
                    window.location = e
                }), 600)), !1
    }))


    //アコーディオンの開閉
    $(".js-content-trg").on("click", (function () {
        $(this).next().slideToggle(),
            $(this).find(".side__ttl-icn").toggleClass("active"),
            $(this).find(".aside__ttl-icn").toggleClass("active")
    }))

    //アーティファクトを知るの個別記事の目次の開閉
    $(".js-mokuji-open").on("click", function () {
        $(this).toggleClass("close").find(".mokuji__ttl-icn").toggleClass("active"),
            $(this).nextAll(".mokuji__list").slideToggle()
    })

    //ショールームページの地域別のアコーディオン
    $('body.handle_shops #shops #nav_pref_shops>ul>li').on('click', function () {
        $('p', this).toggleClass('btn_pref_open')
        $('ul', this).toggleClass('open')
    })

    //ショールームページのSlick
    if($('body').hasClass('page_page_showroom')){
        console.log('ショールームページ')
        $('#slider_shop_access').slick({
            dots: true
        })
    }
    

    //コレクション　randoseruのカラーフィルターのアクティブの判定
    var url = location.pathname
    $('body.page_collection_randoseru #filter_color .color').each(function (color) {
        var link = $('a', this).attr('href')
        if (url.indexOf(link) >= 0) {
            console.log('パラメータ', url, link)
            console.log('色' + link)
            $(this).addClass('active')
        }
    })

    //よくある質問のアコーディオン
    $(document).on("click", ".js-fnc", (function () {
        $(this).next().slideToggle(),
            $(this).find(".fnc__box-ttl-icn").toggleClass("active")
    }))

    //クリップボードにコピー
    $('.js-copy_clipboard').on('click', () => {
        var url = $('.js-copy_clipboard').data('url')
        navigator.clipboard.writeText(url)
        return false
    })

    //ショールームページのカレンダーローディング
    if($('body').hasClass('page_page_showroom')){
        var place = $('body.page_page_showroom #wrap_calendar_calendars').data('place')
        var url = 'https://xs791560.xsrv.jp/common/calendar/cal_' + place + '.html'
        axios.get(url).then(res=>{
            $('body.page_page_showroom #wrap_calendar_calendars').html(res.data)
        })
    }
  
    //フッターのカレンダーローディング
    if($('footer').hasClass('footer2')){
        var place = $('footer.footer2 #ft_wrap_calendar_calendars').data('place')
        var url = 'https://xs791560.xsrv.jp/common/calendar/cal_onlineshop.html'
        axios.get(url).then(res=>{
            $('footer.footer2 #ft_wrap_calendar_calendars').html(res.data)
        })
    }

  
    //トップのMVのスマホ調整
    var h = $(window).height()
    var w = $(window).width()
    if($('body').hasClass('page_index') && w<=600){
        console.log('sp')
        var h_header = $('header').height() + 39
        var h_mv = h - (h_header)
        $('.fv__img').css('paddingBottom',h_mv)
        //$('.fv__img').css('top',h_header)
        $('.fv').height(h_mv + h_header)
        $('.fv').css('paddingTop',h_header)
        $('.fv').css('paddingBottom',h_header)
    }


  
  
})

  
/* ---------------------------
　トップ　スライダー
---------------------------- */

$(function(){
    $('.top_slick').slick({
      autoplay: true, // 自動再生
      autoplaySpeed: 4000,
      arrows: false,
      fade: true,
      speed: 4000,
    });
  });



/*==================================================
バナー系をPC、SPで見た目を変える
==================================================*/
jQuery(window).on('load resize', function () {
    var h_img;
    var h_txt;
    var y;
    var css_value;
    var obj_target;

    jQuery('.bnr_01>a').each(function (index, element) {
        if (jQuery(window).width() < 960) {
            jQuery(this).find('.bnr_txt>.bnr_detail').appendTo(this);
        } else {
            //console.log(jQuery(this).find('img').height()+'  '+jQuery(this).find('h2').height()+' '+jQuery(this).find('.bnr_detail').height()+' '+jQuery(this).find('.bnr_txt').height());
            obj_target = jQuery(this).find('.bnr_txt');
            jQuery(this).find('.bnr_txt+.bnr_detail').appendTo(obj_target);
        }
    })

    jQuery('.bnr_01').each(function (index, element) {
        h_img = jQuery(this).find('img').height();
        h_txt = jQuery(this).find('.bnr_txt').outerHeight();
        y = (h_img - h_txt) / 2;
        css_value = y + 'px';

        jQuery(this).find('.bnr_txt').css('top', css_value);

    })

   

    $('.w-view').on('inview',function(el){
        $(this).css('opacity',1)
    })

    //数秒待っても読み込みが終わらなければ、fadeoutを消す
    const fd_remove = function(){
        if($('body').hasClass('fadeout')){
            $('body').removeClass('fadeout')
        }
    }
    setTimeout(fd_remove,3500)

    
})

$(window).on('load',()=>{
    console.log('loaded')
    $('body').removeClass('fadeout')

    //inViewアニメ
    if($('body').hasClass('page_page_concept')){
        //コンセプトページ
        $('.fadein').css('visibility','visible')
        $('.fadein').on('inview',function(){
            $(this).addClass('is-show')
        })
    }else{
        //コンセプトページ以外
        console.log('コンセプト以外のinview')
        $('.fadein').on('inview',function(){
            $(this).addClass('is-show')
        })
    }
})

// 強制リロード
window.addEventListener('pageshow', function (event) {
    console.log('pageshow')
    if (event.persisted) {
        console.log('persisted')
        $('.footer__copy-txt').html('© 2023 Artifact')
        $('body').removeClass('fadeout')
        $('.fadein').addClass('is-show')
        // bfcache発動時の処理
        //window.location.reload();
    }
});

window.addEventListener('BFCacheLoaded', () => {
    console.log('BFCacheLoaded')
    //alert('back')
});

 //スムーズスクロール
$('a[href^="#"]').click(function () {
    //スクロールの速度
    let speed = 400;
    // スクロールタイプ
    let type = 'swing';
    // href属性の取得
    let href = $(this).attr("href");
    // 移動先の取得（hrefが#indexならトップ$(html)に、）
    let target = $(href == "#index" ? 'html' : href);
    // 移動先のポジション取得
    let position = target.offset().top;
    // animateでスムーススクロール
    $('body,html').animate({
       scrollTop: position
    }, speed, type);
  return false;
})
